export default "__VITE_ASSET__33d75d6b__"